import { Group, Slider, Stack, Text } from "@mantine/core";
import type { AssistantOrbText } from "@/locales/assistant-orb";
import {
	type AssistantOrbConfig,
	ORB_VARIANT_SPECS,
	type OrbParams,
} from "@/types/ai-assistant-orb";

/**
 * Slider parameter. Label dan rentangnya dibaca dari `ORB_VARIANT_SPECS`,
 * bukan ditulis di sini, sehingga menambah atau menyetel ulang sebuah varian
 * tidak menuntut perubahan di komponen ini.
 */
export function OrbParamsEditor({
	config,
	text,
	disabled,
	onChange,
}: {
	config: AssistantOrbConfig;
	text: AssistantOrbText;
	disabled: boolean;
	onChange(params: OrbParams): void;
}) {
	const specs = ORB_VARIANT_SPECS[config.variant];

	if (specs.length === 0) {
		return (
			<Text size="sm" c="dimmed" data-orb-params data-orb-params-empty>
				{text.noParams}
			</Text>
		);
	}

	const setSlot = (index: number) => (value: number) => {
		const next = [...config.params] as [number, number, number, number];
		next[index] = value;
		onChange(next);
	};

	return (
		<Stack gap="xs" data-orb-params>
			{specs.map((spec, index) => (
				<div key={spec.key}>
					<Group justify="space-between" gap="xs" mb={2}>
						<Text size="sm">{text.params[spec.labelKey] ?? spec.key}</Text>
						<Text size="xs" c="dimmed" ff="monospace">
							{config.params[index]}
						</Text>
					</Group>
					<Slider
						min={spec.min}
						max={spec.max}
						value={config.params[index]}
						disabled={disabled}
						label={null}
						data-orb-param={spec.key}
						onChange={setSlot(index)}
					/>
				</div>
			))}
		</Stack>
	);
}
